import { render } from "./core.vue?vue&type=template&id=18570ab3&ts=true"
import script from "./core.vue?vue&type=script&lang=ts"
export * from "./core.vue?vue&type=script&lang=ts"

import exportComponent from "/codebuild/output/src1140266145/src/hackingclub-spa/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__